export enum TabNames {
  NEW = 'nytt',
  ALL = 'alla',
  MISSING = 'saknade'
}